export default __webpack_public_path__ + "static/media/Adult_img.1ad45290.svg";